 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"AdjustmentAnnouncement2025":"AdjustmentAnnouncement2025","Album~AlbumGroup~Christmas2023~DrawIdea~HsjproBrushFree2026~PaintTitle~SpringFestival2024~UserCenter~7d2914d3":"Album~AlbumGroup~Christmas2023~DrawIdea~HsjproBrushFree2026~PaintTitle~SpringFestival2024~UserCenter~7d2914d3","AlbumGroup~DrawIdea~HsjProUsageGuide~HsjProUsageGuidePC~PaintTitle~UserCenter":"AlbumGroup~DrawIdea~HsjProUsageGuide~HsjProUsageGuidePC~PaintTitle~UserCenter","AlbumGroup~CourseDetail~DrawIdea~PaintTitle~UserCenter":"AlbumGroup~CourseDetail~DrawIdea~PaintTitle~UserCenter","AlbumGroup~DrawIdea~PaintTitle~UserCenter":"AlbumGroup~DrawIdea~PaintTitle~UserCenter","AlbumGroup~UserCenter":"AlbumGroup~UserCenter","AlbumGroup":"AlbumGroup","DrawIdea~PaintTitle":"DrawIdea~PaintTitle","DrawIdea":"DrawIdea","PaintTitle":"PaintTitle","HsjproBrushFree2026":"HsjproBrushFree2026","cattea":"cattea","Album~Christmas2023~GiftBag~GiftBagType~HsjProUsageGuide~HsjProUsageGuidePC~OppoBrushGiftBag~OppoGif~310e67a9":"Album~Christmas2023~GiftBag~GiftBagType~HsjProUsageGuide~HsjProUsageGuidePC~OppoBrushGiftBag~OppoGif~310e67a9","HsjProUsageGuide~HsjProUsageGuidePC~riskTip":"HsjProUsageGuide~HsjProUsageGuidePC~riskTip","HsjProUsageGuide~HsjProUsageGuidePC":"HsjProUsageGuide~HsjProUsageGuidePC","HsjProUsageGuide":"HsjProUsageGuide","HsjProUsageGuidePC":"HsjProUsageGuidePC","UserCenter":"UserCenter","Album~SupplementaryReport~VoteDetail~hsj4th~shuangcheng":"Album~SupplementaryReport~VoteDetail~hsj4th~shuangcheng","Album~detail":"Album~detail","Album":"Album","activatevipIndex~transferDeal~transferLogin":"activatevipIndex~transferDeal~transferLogin","activatevipIndex":"activatevipIndex","transferDeal":"transferDeal","transferInfo":"transferInfo","VoteDetail":"VoteDetail","GiftBag":"GiftBag","GiftBagType":"GiftBagType","OppoBrushGiftBag":"OppoBrushGiftBag","OppoGiftBag":"OppoGiftBag","PaintingCompetition":"PaintingCompetition","SupplementaryReport~transferLogin~transferSearch~transferSearchList":"SupplementaryReport~transferLogin~transferSearch~transferSearchList","transferLogin":"transferLogin","transferSearch~transferSearchList":"transferSearch~transferSearchList","transferSearch":"transferSearch","transferSearchList":"transferSearchList","transferBinding":"transferBinding","transferIndex":"transferIndex","transferSuccess":"transferSuccess","transferWorkInfo":"transferWorkInfo","AntiFraudWarning":"AntiFraudWarning","CatTea2025~Christmas2023~CourseDetail~DreamWorld~DreamWorld2025~DreamWorld2026~NoteDownload~ParbloDr~c1b96433":"CatTea2025~Christmas2023~CourseDetail~DreamWorld~DreamWorld2025~DreamWorld2026~NoteDownload~ParbloDr~c1b96433","CourseDetail":"CourseDetail","Christmas2023":"Christmas2023","SpringFestival2024":"SpringFestival2024","VoteIndex":"VoteIndex","activatevipError":"activatevipError","transferError":"transferError","DreamWorld~hsj4th~shuangcheng":"DreamWorld~hsj4th~shuangcheng","hsj4th":"hsj4th","shuangcheng":"shuangcheng","SupplementaryReport":"SupplementaryReport","detail":"detail","CatTea2025~DreamWorld2026~ParbloPadBlue~ParbloPadGreen~ParbloPadIdleTime~ParbloPadPurple~ParbloPage~~e33949b2":"CatTea2025~DreamWorld2026~ParbloPadBlue~ParbloPadGreen~ParbloPadIdleTime~ParbloPadPurple~ParbloPage~~e33949b2","CatTea2025":"CatTea2025","DreamWorld2026":"DreamWorld2026","ParbloPadBlue":"ParbloPadBlue","ParbloPadGreen":"ParbloPadGreen","ParbloPadIdleTime":"ParbloPadIdleTime","ParbloPadPurple":"ParbloPadPurple","ParbloPage":"ParbloPage","ParbloPrizeDetail":"ParbloPrizeDetail","ParbloWifiHsj":"ParbloWifiHsj","ParbloWifiHsjPro":"ParbloWifiHsjPro","PromotionPage":"PromotionPage","Recruit2025OperationsStaff":"Recruit2025OperationsStaff","Recruit2026ContentModeration":"Recruit2026ContentModeration","Recruit2026CustomerAndReporting":"Recruit2026CustomerAndReporting","Recruit2026Reporting":"Recruit2026Reporting","Recruitment2025":"Recruitment2025","XppenArtist12":"XppenArtist12","XppenArtist16":"XppenArtist16","XppenDeco":"XppenDeco","XppenDecoSEMobile":"XppenDecoSEMobile","DreamWorld2025":"DreamWorld2025","DreamWorld":"DreamWorld","NoteDownload":"NoteDownload","ParbloDreamWorld2024":"ParbloDreamWorld2024","course":"course","expWait":"expWait","share":"share","ConcaveAndConvexWorld":"ConcaveAndConvexWorld","DraftSaveHsjPro2025":"DraftSaveHsjPro2025","DrawIdeaRejectionExplanation":"DrawIdeaRejectionExplanation","DriverUpgrade":"DriverUpgrade","FairiesAlbums2024":"FairiesAlbums2024","GroupChatOffline":"GroupChatOffline","riskTip":"riskTip","HsjproBluetoothTablet2026":"HsjproBluetoothTablet2026","HsjproBrushUpgrade2026":"HsjproBrushUpgrade2026","HsjproCloudDraft":"HsjproCloudDraft","HsjproHarmonyNextStorage2026":"HsjproHarmonyNextStorage2026","HsjproPCEarlyAccess":"HsjproPCEarlyAccess","IndividualIncomeTax":"IndividualIncomeTax","LagSolutionGuide":"LagSolutionGuide","LanternFestival":"LanternFestival","Notice":"Notice","ParbloDreamWorld":"ParbloDreamWorld","PcDownload":"PcDownload","RecruitService":"RecruitService","ShanHaiColor":"ShanHaiColor","TitleManagementRule":"TitleManagementRule","TypicalProblem":"TypicalProblem","XppenDecoSE":"XppenDecoSE","download":"download","expQueue":"expQueue","hsjProDownload":"hsjProDownload","interview":"interview","qualifyHome":"qualifyHome","qualifyPreorder":"qualifyPreorder","qualifySeller":"qualifySeller","test":"test"}[chunkId]||chunkId) + "." + "a51251c0" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cdn.huashijie.art/hsj/wap/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
